<template>
    <div class="backlist inconbox">
        <a :href="back_url">Back to list</a>
    </div>
</template>
<script>
export default{
    data(){
        return {
            //返回的列表
            back_url:"#"
        };
    },
    props:["back_url"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{},
    methods:{
        init(){
            this.back_url = this.back_url;
        }
    }
}
</script>